import React, { useState as uState } from 'react'

import Navbar from '../../Components/Navbar/navbar'
import Footer from '../../Components/Footer/footer'


import {Link} from 'react-router-dom'
import { useNavigate as uNavigate } from 'react-router-dom'

import Med from '../../assets/images/medicines.png'
import './Login.css'
// import Fb from '../../assets/images/fb.png'
// import Twitt from '../../assets/images/twitter.png'
// import Insta from '../../assets/images/instagram.png'

export default function login() {
  const navigate = uNavigate()
  const [user, setUser] = uState({
    email: "",
    password: ""
  })
 

  const handleChange = (event) => {
    setUser({
      ...user,
      [event.target.name]: event.target.value
    })
  }

  
  
  
  const handleSubmit = async (e) => {

    if (user.email === '' || user.password  === '') {
      console.log('enter credentials first')
    } else {
      e.preventDefault()
      const response = await fetch('http://localhost:8000/users/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: user.email ,
          password: user.password
        })
      })
      const json = await response.json()
      if (!json.success) {
        alert('enter valid inputs')
      }
      else {
        localStorage.setItem('userEmail', user.email )        
        localStorage.setItem('authToken', json.authToken)
        navigate('/')
      }

    }
  }
  const handleUser = async (e) => {
    e.preventDefault()
    let AdminEmail = document.getElementById('form3Example3').value
    let AdminPass = document.getElementById('form3Example4').value
    let adminStyle=document.getElementById('admin').style
    if (AdminEmail === 'Admin@gmail.com' && AdminPass === 'Purav@2000') {
      localStorage.setItem('adminEmail',AdminEmail)
      adminStyle.display='block'
    }
    else {
    handleSubmit(e)
    }
  }

  const handleShowPass = () => {
    const Text = document.getElementById('form3Example4')
    const InnerHtml = document.getElementById('showPass')
    if (Text.type === 'password') {
      Text.type = 'text'
      InnerHtml.innerHTML = 'Hide Password'
    }
    else {
      Text.type = 'password'
      InnerHtml.innerHTML = 'Show Password'
    }


  }
  return (

    <>
      <Navbar/>
      <Link to='/admin' id='admin' className='text-center' style={{ display: 'none' }}><button className='btn btn-success '>Go To Admin DashBoard</button></Link>
    <section className="vh-100 ">
  <div className="container-fluid h-custom">
    <div className="row d-flex justify-content-center align-items-center h-100">
            <div className="col-md-9 col-lg-6 col-xl-5 medicines">
                  <img src={Med} className="img-fluid" alt="Sampleimage" />            
      </div>
      <div className="col-md-8 col-lg-6 col-xl-4 offset-xl-1">
              <form onSubmit={handleUser}>
          {/* <div className="d-flex flex-row align-items-center justify-content-center justify-content-lg-start">
            <p className="lead fw-normal mb-0 me-3">Sign in with</p>
                  <button onClick={login} className='socialL mx-1'>
              <img src={Fb} alt="" className="s-1" width='30px'/>
            </button>
            <a href="#!" className='socialL mx-1'>
              <img src={Twitt} alt="" className="s-2 " width='30px'/>
            </a>
            <a href="#!" className='socialL mx-1'>
              <img src={Insta} alt="" className="s-3" width='30px'/>
            </a>
          </div> */}

          <div className="divider d-flex align-items-center my-4">
            <p className="text-center fw-bold mx-3 mb-0">Or</p>
          </div>

          <div className="form-outline mb-4">
            <input required type="email" id="form3Example3" className="form-control form-control-lg"
              name="email" value={user.email} onChange={handleChange}  placeholder="Enter a valid email address" />
            <label className="form-label" htmlFor="form3Example3">Email address</label>
          </div>


          <div className="form-outline mb-3">
            <input required type="password" id="form3Example4" className="form-control form-control-lg"
              name="password" value={user.password} onChange={handleChange}  placeholder="Enter password" />
            <label className="form-label" htmlFor="form3Example4">Password</label>
          </div>

          <div className="d-flex justify-content-between align-items-center">
            <div className="form-check mb-0">
                    <input onClick={handleShowPass} className="form-check-input me-2" type="checkbox" value="" id="form2Example3" />
                    <label id='showPass' className="form-check-label" htmlFor="form2Example3">
                      Show Password
                    </label>
            </div>
            <Link to='/forgetPassword' className="">Forgot password?</Link>
          </div>

                <div className="text-center text-lg-start  mt-1 pt-2">
     
            <button type="submit" className="btn btncolor btn-lg" id='Loginbtn' style={{paddingLeft: '2.5rem',paddingRight: '2.5rem'}}>Login</button>
            <p className="small fw-bold mt-1 pt-1 mb-0">Don't have an account? <Link to="/register"
                className="link-danger">Register</Link></p>
          </div>

        </form>
      </div>
    </div>
  </div>
  
</section>
    <Footer/>
    </>
  )
}
